import { AccountCircle, Phone } from '@mui/icons-material';
import { Grid, Skeleton, styled, Typography } from '@mui/material';
import React from 'react';
import { useLwp } from '../../hooks/use-lwp';
import useLwpWidgetProps from '../../hooks/use-lwp-widget-props/hooks';
import { formatUSPhoneNumber } from '../../utils/formatter';
import { CallBox, CallButton, CallHeader, CallStateActive } from './call-styles';

const AnimatedBar = styled(Skeleton)((style) => ({
  backgroundColor: style.theme.palette.success.main,
  position: 'relative',
  height: 12
}));

interface CallHandler {
  (): void;
}

export function CallInboundView(props: {
  phoneNumber: string | undefined;
  onHangup?: CallHandler;
  onAnswer?: CallHandler;
}) {
  const {
    phoneState: { contactName }
  } = useLwp();
  const { widgetProps } = useLwpWidgetProps();

  const showProfile = () => {
    const fireProfile = async () => {
      if (widgetProps && widgetProps.events && props.phoneNumber && widgetProps.events.onPatientProfileClick)
        widgetProps.events.onPatientProfileClick(props.phoneNumber);
    };
    fireProfile();
  };

  return (
    <div style={{ position: 'relative' }}>
      <CallBox data-testid="call-inbound">
        <AnimatedBar animation="pulse" variant="rectangular" />
        <CallHeader>
          <Grid container>
            <Grid item xs={6} zeroMinWidth>
              <CallStateActive>INCOMING CALL</CallStateActive>
              <Typography variant="h6" noWrap>
                {contactName ? contactName : ''}
              </Typography>
              <Typography variant="body2">{formatUSPhoneNumber(props.phoneNumber)}</Typography>
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'right' }}>
              <CallButton disabled={contactName === undefined} onClick={showProfile}>
                <AccountCircle />
              </CallButton>
              {props.onHangup && (
                <CallButton
                  onClick={props.onHangup}
                  sx={{ backgroundColor: 'rgb(244, 73, 72)', '&:hover': { backgroundColor: 'rgb(244, 73, 72)' } }}
                >
                  <Phone
                    sx={{
                      transform: 'rotate(135deg)'
                    }}
                  />
                </CallButton>
              )}
              {props.onAnswer && (
                <CallButton
                  onClick={props.onAnswer}
                  sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}
                >
                  <Phone />
                </CallButton>
              )}
            </Grid>
          </Grid>
        </CallHeader>
      </CallBox>
    </div>
  );
}
